import { I18nText } from '../types';

const createI18n = <T extends { [key: string]: I18nText<any>; }>(i18n: T) => {
	return i18n;
}

export default createI18n;